import { format } from '@dynatrace-sdk/units';

import type { DataTableV2CellFormatter } from '../../../../tables/DataTableV2/features/CellFormatter.js';
import { ChartTooltip } from '../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';
import { RangeHeader } from '../../../core/components/tooltip/ChartTooltip/components/RangeHeader/RangeHeader.js';
import { TextHeader } from '../../../core/components/tooltip/ChartTooltip/components/TextHeader.js';
import type { GanttSegmentData } from '../../types/gantt-chart.js';

export const GanttChartTooltipHeader = ({
  segment,
  isDate,
  formatter,
}: {
  segment: Pick<GanttSegmentData, 'start' | 'end'>;
  isDate: boolean;
  formatter?: DataTableV2CellFormatter;
}) => {
  const [start, end] = [segment.start, segment.end];
  if (isDate) {
    return end === undefined || start === end ? (
      <ChartTooltip.TimestampHeader date={new Date(start)} />
    ) : (
      <ChartTooltip.TimeFrameHeader
        showDuration
        from={new Date(start)}
        to={new Date(end)}
      />
    );
  }

  return end === undefined || start === end ? (
    <TextHeader text={format(start, formatter)} />
  ) : (
    <RangeHeader
      from={start}
      to={end}
      formatter={(value: number) => format(value, formatter)}
    />
  );
};
